<template>
  <div class="app-main-content businessIntelligenceDashboard">
    <div class="tab-list">
      <span v-for="(item, index) in tabList" :key="index" class="tab-item" :class="{'selectColor': tabIndex === item.dashboardId}" @click="selectMenuItem(item, item.dashboardId)">{{ item.name }}</span>
    </div>
    <div class="dashboard-right">
      <!-- type === 0为BI仪表盘  entrance ===  TAB 代表从系统维护-BI图表管理模块进入BI仪表盘页签-->
      <div v-show="entrance === 'TAB'" class="operation">
        <el-button type="primary" @click="addDashboard">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.addDashboard') }}</el-button>
        <el-button v-show="tabItem.name !== $t('BiAnalysis.DefaultDashboard') && tabItem.name" type="primary" @click="editDashboard">{{ $t('BusinessIntelligence.common.edit') }}</el-button>
        <el-button v-show="tabItem.name" type="danger" @click="deleteDashboardFunc">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.delete') }}</el-button>
      </div>
      <div v-show="entrance !== 'TAB'" class="operation">
        <el-button type="primary" @click="fullScreen">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.fullScreen') }}</el-button>
      </div>
      <!-- type === 1为自定义仪表盘 -->
      <div class="section dashboard">
        <div v-show="tabItem.type === 1 && entrance === 'TAB'" class="custom-operation">
          <el-button type="primary" @click="settingFilters">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.setFilter') }}</el-button>
          <el-button type="primary" @click="preview">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.preview') }}</el-button>
          <el-button type="primary" @click="saveLayout">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.saveLayout') }}</el-button>
          <el-button type="primary" @click="addChart">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.addChart') }}</el-button>
        </div>
        <div v-show="tabItem.type === 1 && entrance === 'TAB'" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="margin:10px 0;font-size:16px;">{{ tabItem.name }}</div>
          <span style="font-size:14px;color:#409eff;">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.dragTips') }}</span>
        </div>
        <div class="dashboard-content" :class="{'scroll': freeDashboard || (tabItem.type === 1 && entrance === 'TAB') }">
          <img v-if="freeDashboard && isBiDashboard" :src="matchImg(tabItem.name)" @click="defaultDashboardClicked()">
          <div
            v-if="!freeDashboard && isBiDashboard"
            id="iframeContainer"
            ref="iframeContainer"
            style="position: relative; width: 100%; height: 100%;"
          >
            <div v-if="freeCustomer" style="position: absolute; top: 0; bottom: 0; right: 0; left: 0;" @click="defaultDashboardClicked()" />
            <iframe
              v-if="!freeDashboard && isBiDashboard"
              id="dashboardIframe"
              ref="dashboardIframe"
              :src="tabItem.url"
              frameborder="0"
              allowtransparency
              width="100%"
              height="100%"
            />
          </div>
          <grid-layout
            v-show="tabItem.type === 1 && entrance === 'TAB'"
            :layout.sync="customChart"
            :col-num="18"
            :row-height="60"
            :is-draggable="true"
            :is-resizable="true"
            :is-mirrored="false"
            :auto-size="true"
            :use-css-transforms="true"
            :vertical-compact="true"
            :margin="[10, 10]"
          >

            <grid-item
              v-for="item in customChart"
              :key="item.i"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
            >
              <div class="dashboard-item">
                <div style="flex:1;">
                  <iframe
                    :src="item.url"
                    frameborder="0"
                    scrolling="no"
                    allowtransparency
                    width="100%"
                    height="100%"
                  />
                </div>
                <div class="dashboard-item-operation">
                  <span>{{ item.name }}</span>
                  <span>
                    <i class="el-icon-close" @click="deletes(item)" />
                  </span>
                </div>
              </div>
            </grid-item>
          </grid-layout>
        </div>
      </div>
    </div>
    <!-- 添加仪表盘 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addDashboardShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      :title="dialogTitle"
      :editable="true"
      :width="dashboardForm.type === 1 && dialogType === 'add'?'900px':'450px'"
    >
      <div class="dialog-content">
        <div v-show="!addChartShow" class="content-left">
          <el-form ref="form" :inline="true" :model="dashboardForm" label-width="100px" :rules="rules" @submit.native.prevent>
            <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.dashboardType')" prop="type" :show-message="false">
              <el-radio-group v-model="dashboardForm.type">
                <el-radio :label="1" :disabled="dialogType === 'edit'">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.customizeDashboard') }}</el-radio>
                <el-radio :label="0" :disabled="dialogType === 'edit'">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.biDashboard') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.dashboardName')" prop="name" :show-message="false">
              <el-input v-model="dashboardForm.name" :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.dashboardNamePlaceholder')" class="input-width" />
            </el-form-item>
            <el-form-item v-show="dashboardForm.type === 1" :label="$t('BusinessIntelligence.businessIntelligenceDashboard.classification')" :show-message="false">
              <el-select v-model="dashboardForm.dashboardType" style="width:200px;" @change="selectDashbaordType">
                <el-option
                  v-for="item in dashboardTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="dashboardForm.type === 0" :label="$t('BiAnalysis.BIDashboardSource')" prop="biDashboardSource" :show-message="false">
              <el-select v-model="dashboardForm.biDashboardSource" :disabled="dialogType === 'edit' && !freeDashboard" style="width:200px;">
                <el-option
                  v-for="(item, index) in domaineNames"
                  :key="index"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="dashboardForm.type === 0" :label="$t('BusinessIntelligence.businessIntelligenceDashboard.biDashboardId')" prop="dashboardId" :show-message="false">
              <el-input v-model="dashboardForm.dashboardId" :disabled="dialogType === 'edit' && !freeDashboard" :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.biDashboardIdPlaceholder')" class="input-width" />
            </el-form-item>
            <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.Notes')" :show-message="false">
              <el-input v-model="dashboardForm.remark" type="textarea" :rows="5" style="width:250px;" />
            </el-form-item>
            <div class="permissions">
              <div class="permissions-title">
                <i class="color-piece" />
                <span>{{ $t('BusinessIntelligence.businessIntelligenceDashboard.setAccessRights') }}</span>
                <i class="el-icon-warning" style="font-size:14px;color:#1F75D5;" @click="prompt" />
              </div>

              <div class="align-center">
                <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.selectBranch')" prop="accessCompanyId" :show-message="false">
                  <cargo-advance-select
                    filter-type="global"
                    :filter-tag-names="['name', 'code']"
                    :disabled="selectAllBranch"
                    :static-options="accessPermissions.branchList"
                    :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.selectBranchPlaceholder')"
                    style="width:200px;"
                    filterable
                    multiple
                    tag-name="code"
                    :default-multiple-value="accessCompanyList"
                    @parentCallBack="p=>selectBranch(p)"
                  />
                </el-form-item>
                <el-checkbox v-model="selectAllBranch" @change="changeBranchAll">{{ $t('BusinessIntelligence.businessIntelligence.all') }}</el-checkbox>
              </div>

              <div class="align-center">
                <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.selectDepartment')" :show-message="false">
                  <cargo-advance-select
                    :disabled="selectAllDepartment || selectAllBranch"
                    :static-options="accessPermissions.departmentList"
                    :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.selectDepartmentPlaceholder')"
                    style="width:200px;"
                    filterable
                    multiple
                    tag-name="chineseName"
                    tag-value="departmentId"
                    :default-multiple-value="dashboardForm.accessDeptId"
                    :show-custom-label-in-option="true"
                    :custom-label="toDepartmentLabel"
                    :filter-after-fetch-data="true"
                    @parentCallBack="getPersonnelList"
                  />
                </el-form-item>
                <el-checkbox v-model="selectAllDepartment" :disabled="selectAllBranch" @change="changeDepartmentAll">{{ $t('BusinessIntelligence.businessIntelligence.all') }}</el-checkbox>
              </div>

              <div class="align-center">
                <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.selectPersonnel')" :show-message="false">
                  <cargo-advance-select
                    :disabled="selectAllPersonnel || selectAllDepartment || selectAllBranch"
                    :static-options="accessPermissions.personnelList"
                    :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.selectPersonnelPlaceholder')"
                    style="width:200px;"
                    filterable
                    multiple
                    tag-name="chineseName"
                    tag-value="userId"
                    :default-multiple-value="dashboardForm.accessUserId"
                    :show-custom-label-in-option="true"
                    :custom-label="toUserLabel"
                    :filter-after-fetch-data="true"
                    @parentCallBack="item=>dashboardForm.accessUserId = item.value"
                  />
                </el-form-item>
                <el-checkbox v-model="selectAllPersonnel" :disabled="selectAllDepartment || selectAllBranch" @change="changePersonnelAll">{{ $t('BusinessIntelligence.businessIntelligence.all') }}</el-checkbox>
              </div>

              <div class="permissions-title">
                <i class="color-piece" />
                <span>{{ $t('BusinessIntelligence.businessIntelligenceDashboard.setDataPermission') }}</span>
              </div>
              <el-checkbox-group v-model="dashboardForm.dataAccess" style="margin-left:10px;" @change="statusChanges">
                <el-checkbox label="0">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.whole') }}</el-checkbox>
                <!--                <el-checkbox label="1">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.company') }}</el-checkbox>-->
                <!--                <el-checkbox label="2">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.department') }}</el-checkbox>-->
                <el-checkbox label="3">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.personal') }}</el-checkbox>
                <el-checkbox label="4">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.rolePermissions') }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form>
        </div>
        <div v-show="dashboardForm.type === 1 && dialogType === 'add' || addChartShow" class="content-right">
          <div>
            <span class="content-right-title">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.chartAddDashboard') }}</span>
            <div class="content-right-operation">
              <input v-model="chartName" :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.queryChartName')" class="set-input">
              <el-button type="primary" style="margin-left:10px;" @click="searchChart">{{ $t('BusinessIntelligence.common.query') }}</el-button>
            </div>
          </div>
          <div style="margin-top:10px;flex:1;">
            <cargo-ag-grid
              style="height:100%;"
              config-module="2022083101"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="chartList"
            />
          </div>
        </div>
      </div>
      <div style="text-align:right;margin-top:20px;">
        <el-button type="primary" size="mini" @click="dialogConfirm">{{ $t('BusinessIntelligence.common.save') }}</el-button>
        <el-button size="mini" @click="dialogCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 自定义仪表盘添加图表 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addChartShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      :title="dialogTitle"
      :editable="true"
      width="600px"
    >
      <div class="dialog-content">
        <div class="content-right">
          <span class="content-right-title">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.chartAddDashboard') }}</span>
          <div class="content-right-operation">
            <input v-model="chartName" :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.queryChartName')" class="set-input">
            <el-button type="primary" style="margin-left:10px;" @click="filterChart">{{ $t('BusinessIntelligence.common.query') }}</el-button>
          </div>
          <div style="margin-top:10px;">
            <cargo-ag-grid
              style="height:300px;"
              config-module="2022091901"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="addChartList"
            />
          </div>
        </div>
      </div>
      <div style="text-align:right;margin-top:20px;">
        <el-button type="primary" size="mini" @click="addChartConfirm">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.add') }}</el-button>
        <el-button size="mini" @click="addChartCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 设置查询项 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="queryItemShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      :title="$t('BusinessIntelligence.businessIntelligenceDashboard.setQueryItem')"
      :editable="true"
      width="500px"
    >
      <div style="padding:0 10px;box-sizing:border-box;">
        <el-form :inline="true" @submit.native.prevent>
          <div style="display: flex;flex-wrap: wrap;">
            <el-checkbox v-for="(item, index) in queryItem" :key="index" v-model="item.selected" :label="item.name" style="margin:0;width:25%;" />
          </div>
        </el-form>
        <div class="query-item-footer">
          <span>{{ $t('BusinessIntelligence.businessIntelligenceDashboard.seePreview') }}</span>
          <div>
            <el-button type="primary" size="mini" @click="queryItemSave">{{ $t('BusinessIntelligence.businessIntelligenceDashboard.determine') }}</el-button>
            <el-button size="mini" @click="queryItemShow = false">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 预览 -->
    <transition name="el-fade-in-linear">
      <div v-if="previewShow" class="mask">
        <div class="mask-content">
          <i class="el-icon-close close" @click=" previewShow = false" />
          <iframe
            :src="tabItem.url"
            frameborder="0"
            allowtransparency
            scrolling="yes"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import VueGridLayout from 'vue-grid-layout'
import { getLoading } from '@/utils/utilBaseElement'
import { cacheName, cache } from '@/utils/cacheManager'
import { chartConfig } from '@/api/sysManage/businessIntelligence/businessIntelligenceChart'
import { getList, add, deleteDashboard, getUsersByOfficeAndDept, editDashboard, getCards, getFilterList, saveFilters } from '@/api/sysManage/businessIntelligence/businessIntelligenceDashboard'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { cacheKeys, getFilterCacheList } from '@/utils/basicDataCache'
import DateUtils from '@/utils/dateUtils'
import * as BiConstants from '@/class/cargo/model/parameters/BiConstants'
import { sortByMultiField } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'BusinessIntelligenceDashboard',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    CargoAdvanceSelect
  },
  props: {
    entrance: { // 系统维护进来，会传TAB
      type: String,
      default: ''
    }
  },
  data() {
    return {
      multipleVal: true,
      index: 1,
      deleteCharts: [],
      addChartShow: false,
      customChart: [],
      nameList: [],
      dialogType: '',
      dialogTitle: this.$t('BusinessIntelligence.businessIntelligenceDashboard.addDashboard'),
      previewShow: false,
      addDashboardShow: false,
      dashboardForm: {
        type: 1,
        dashboardType: 0,
        name: '',
        biDashboardSource: '',
        dashboardId: '',
        remark: '',
        accessCompanyId: [],
        accessDeptId: [],
        accessUserId: [],
        dataAccess: ['4'],
        chartData: []
      },
      accessCompanyList: [],
      selectAllBranch: true,
      selectAllDepartment: true,
      selectAllPersonnel: true,
      chartName: '',
      checkedId: '3',
      queryItem: [],
      queryItemShow: false,
      accessPermissions: {
        branchList: [],
        departmentList: [],
        personnelList: []
      },
      dashboardTypeList: [
        { name: this.$t('BusinessIntelligence.businessIntelligenceDashboard.businessDashboard'), id: 0 },
        { name: this.$t('BusinessIntelligence.businessIntelligenceDashboard.financialDashboard'), id: 1 }
      ],
      tabList: [],
      tabIndex: '',
      tabItem: {},
      rowData: [],
      chartList: [],
      addChartList: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: event => {
          this.dashboardForm.chartData = event.api.getSelectedRows()
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligenceChart.chartName'),
          field: 'name',
          width: 100
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligenceDashboard.grouping'),
          field: 'groupName',
          width: 150
        },
        {
          headerName: this.$t('BusinessIntelligence.chartGroupSetting.chartDescription'),
          field: 'remark',
          width: 150
        }
      ],
      rules: {
        type: [
          {
            required: true
          }
        ],
        name: [
          {
            required: true
          }
        ],
        biDashboardSource: [
          {
            required: true
          }
        ],
        dashboardId: [
          {
            required: true
          }
        ],
        accessCompanyId: [
          {
            required: true
          }
        ]
      },
      domaineNames: [],
      freeCustomer: false // 是否体验使用客户
    }
  },
  computed: {
    isBiDashboard() { // BI仪表盘
      return this.tabItem.type === 0 || this.entrance !== 'TAB'
    },
    freeDashboard() { // 免费仪表盘
      return this.tabItem.type === 0 && this.tabItem.dashboardId && Number(this.tabItem.dashboardId) <= 0
    },
    isDefaultDashboard() { // 免费用户默认仪表盘点击弹蒙层，后端的名字就叫“默认仪表盘”
      return this.tabItem.name === '默认仪表盘'
    }
  },
  watch: {
    'dashboardForm.accessCompanyId': {
      handler(newValue, oldValue) {
        if (newValue.length === 0) {
          this.dashboardForm.accessDeptId = []
          this.dashboardForm.accessUserId = []
          this.accessCompanyList = newValue
        }
      },
      deep: true
    },
    'dashboardForm.accessDeptId': {
      handler(newValue, oldValue) {
        if (newValue.length === 0) {
          this.dashboardForm.accessUserId = []
        }
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      handler() {
        this.getListFunc('default') // 获取仪表盘列表
      }
    },
    '$store.getters.currentDeptId': {
      handler() {
        this.getListFunc('default') // 获取仪表盘列表
      }
    }
  },
  created() {
    this.getListFunc('default') // 获取仪表盘列表
    this.prepareData()
    chartConfig().then(res => {
      this.freeCustomer = res.data.remark && (res.data.remark.trim() === '体验使用')
      this.domaineNames = Array.from(res.data.biDomainName.split('|'), p => p.trim())
    })
  },
  mounted() {
    setTimeout(() => {
      const biInvalidDate = this.$store.state.settings.bsLimitInfo.biInvalidDate
      if (biInvalidDate && biInvalidDate < DateUtils.formatStandardDate(new Date())) {
        this.$confirm(this.$t('BiAnalysis.BiExpiredTip'), this.$t('SystemMaintenance.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('tagsView/delView', this.$route).then(({ visitedViews }) => {
            this.toLastView(visitedViews)
          })
        }).catch(() => {})
      }
    }, 100)
  },
  methods: {
    // 获取仪表盘筛选项
    async getFilterListFunc() {
      this.loading = getLoading()
      const data = {
        dashboardId: this.tabItem.dashboardId
      }
      const res = await getFilterList(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        // dashboardType === 1 为财务筛选项
        if (this.tabItem.dashboardType === 1) {
          this.queryItem = res.data.finance
        } else {
          this.queryItem = res.data.business
        }
      }
    },
    // 获取仪表盘列表
    async getListFunc(value) {
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        deptId: this.$store.getters.currentDeptId
      }
      this.entrance === 'TAB' ? data.showAll = true : data.showAll = false
      this.loading = getLoading()
      const res = await getList(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.nameList = []
        this.tabList = (this.freeCustomer && res.data.length > 0) ? sortByMultiField(res.data, ['dashboardId'], true) : res.data
        if (res.data.length > 0) {
          res.data.map((item) => {
            this.nameList.push(item.name)
          })
        }
        // 初次进入默认选中第一个
        if (value === 'default' && res.data.length > 0) {
          // 不能选免费使用的虚拟仪表盘
          for (const curData of res.data) {
            if (curData.dashboardId && Number(curData.dashboardId) > 0) {
              this.tabItem = curData
              break
            }
          }
          this.tabIndex = this.tabItem.dashboardId
        }
        if (value === 'edit') {
          const editData = res.data.filter((item) => {
            return this.tabItem.dashboardId === item.dashboardId
          })
          this.tabItem = editData[0]
        }
        if (value === 'custom') {
          const tabItem = res.data.filter((item) => {
            return this.tabItem.dashboardId === item.dashboardId
          })
          this.tabItem.url = tabItem[0].url
        }
      }
    },
    // 菜单选择
    async selectMenuItem(item, dashboardId) {
      if (item.children.length > 0) {
        item.children.forEach((item) => {
          item.i = item.chartId
          item.y = item.chartRow
          item.x = item.chartColumn
          item.w = item.chartWidth
          item.h = item.chartHeight
        })
      }
      this.customChart = JSON.parse(JSON.stringify(item.children)) || []
      this.tabIndex = dashboardId
      this.tabItem = item
    },
    // 删除仪表盘
    deleteDashboardFunc() {
      this.$confirm(this.$t('BusinessIntelligence.businessIntelligenceDashboard.deleteConfirm'), this.$t('BusinessIntelligence.businessIntelligenceDashboard.tips'), {
        confirmButtonText: this.$t('BusinessIntelligence.businessIntelligenceDashboard.determine'),
        cancelButtonText: this.$t('BusinessIntelligence.common.cancel'),
        type: 'warning'
      }).then(() => {
        const data = {
          dashboardId: this.tabItem.dashboardId
        }
        this.loading = getLoading()
        deleteDashboard(data).then((res) => {
          if (res.ok) {
            this.getListFunc('default')
            this.$message.success(this.$t('BusinessIntelligence.chartGroupSetting.deleteSuccess'))
          }
        }).catch(() => {
          this.loading.close()
        })
      })
    },
    // 设置筛选项
    async settingFilters() {
      await this.getFilterListFunc()
      this.queryItemShow = true
    },
    // 设置查询项窗口保存
    async queryItemSave() {
      const data = {
        dashboardId: this.tabItem.dashboardId,
        biFilterInfoList: []
      }
      data.biFilterInfoList = this.queryItem.filter((item) => {
        return item.selected
      })
      this.loading = getLoading()
      const res = await saveFilters(data).catch(() => {
        this.loading.close()
      })
      if (res.ok) {
        await this.getListFunc('custom')
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
        this.queryItemShow = false
      }
    },
    // 预览
    preview() {
      this.previewShow = true
    },
    // 新增接口
    async addSave() {
      const data = {
        name: this.dashboardForm.name,
        type: this.dashboardForm.type,
        accessCompanyId: this.dashboardForm.accessCompanyId,
        accessDeptId: this.dashboardForm.accessDeptId,
        accessUserId: this.dashboardForm.accessUserId
      }
      if (this.selectAllBranch) {
        data.accessCompanyId = 0
      } else {
        if (!this.dashboardForm.accessCompanyId.length) {
          this.$message.warning('请选择分公司')
          return
        }
      }
      if (this.selectAllDepartment) {
        data.accessDeptId = 0
      } else {
        if (!this.dashboardForm.accessDeptId.length) {
          this.$message.warning(this.$t('BiAnalysis.PleaseSelectADepartment'))
          return
        }
      }
      if (this.selectAllPersonnel) {
        data.accessUserId = 0
      } else {
        if (!this.dashboardForm.accessUserId.length) {
          this.$message.warning(this.$t('BiAnalysis.PleaseChooseDepartmentPersonnel'))
          return
        }
      }
      if (this.dashboardForm.type === 1) {
        data.dashboardType = this.dashboardForm.dashboardType
      } else {
        data.biDashboardSource = this.dashboardForm.biDashboardSource
        data.dashboardId = Number(this.dashboardForm.dashboardId)
      }
      this.dashboardForm.remark ? data.remark = this.dashboardForm.remark : ''
      data.accessDataType = Number(this.dashboardForm.dataAccess[0])
      if (this.dashboardForm.chartData.length > 0 && this.dashboardForm.type === 1) {
        const arr = []
        this.dashboardForm.chartData.forEach((item) => {
          arr.push({
            chartId: item.chartId
          })
        })
        data.children = arr
      }
      data.accessCompanyId = data.accessCompanyId.toString()
      data.accessDeptId = data.accessDeptId.toString()
      data.accessUserId = data.accessUserId.toString()
      this.loading = getLoading()
      const res = await add(data).catch(() => {
        this.loading.close()
      })
      if (res.ok) {
        await this.getListFunc()
        this.dialogCancel()
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
      }
    },
    // 仪表盘编辑保存
    async editSave() {
      const data = {
        name: this.dashboardForm.name,
        type: this.dashboardForm.type,
        accessCompanyId: this.dashboardForm.accessCompanyId,
        accessDeptId: this.dashboardForm.accessDeptId,
        accessUserId: this.dashboardForm.accessUserId
      }
      if (this.selectAllBranch) {
        data.accessCompanyId = 0
      } else {
        if (!this.dashboardForm.accessCompanyId.length) {
          this.$message.warning('请选择分公司')
          return
        }
      }
      if (this.selectAllDepartment) {
        data.accessDeptId = 0
      } else {
        if (!this.dashboardForm.accessDeptId.length) {
          this.$message.warning(this.$t('BiAnalysis.PleaseSelectADepartment'))
          return
        }
      }
      if (this.selectAllPersonnel) {
        data.accessUserId = 0
      } else {
        if (!this.dashboardForm.accessUserId.length) {
          this.$message.warning(this.$t('BiAnalysis.PleaseChooseDepartmentPersonnel'))
          return
        }
      }
      if (this.dashboardForm.type === 1) {
        data.dashboardType = this.dashboardForm.dashboardType
      }
      data.biDashboardSource = this.dashboardForm.biDashboardSource
      data.dashboardId = Number(this.dashboardForm.dashboardId)
      this.dashboardForm.remark ? data.remark = this.dashboardForm.remark : ''
      data.accessDataType = Number(this.dashboardForm.dataAccess[0])
      data.accessCompanyId = data.accessCompanyId.toString()
      data.accessDeptId = data.accessDeptId.toString()
      data.accessUserId = data.accessUserId.toString()
      this.loading = getLoading()
      const res = await editDashboard(data).catch(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (this.dashboardForm.type === 1) {
          this.queryChart(true)
        }
        await this.getListFunc('edit')
        this.dialogCancel()
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
      }
    },
    // 自定义仪表盘保存布局
    async saveLayout() {
      const data = {
        dashboardId: this.tabItem.dashboardId,
        children: []
      }
      if (this.customChart.length > 0) {
        this.customChart.map((item) => {
          data.children.push({
            chartId: item.chartId,
            chartRow: item.y,
            chartColumn: item.x,
            chartWidth: item.w,
            chartHeight: item.h,
            chartIndex: 0
          })
        })
      }
      this.loading = getLoading()
      const res = await editDashboard(data).catch(() => {
        this.loading.close()
      })
      if (res.ok) {
        await this.getListFunc('custom')
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
      }
    },
    // 自定义仪表盘添加图表
    async addChart() {
      this.dialogTitle = this.$t('BusinessIntelligence.businessIntelligenceDashboard.addChart')
      await this.queryChart(true, 'addChart')
      this.addChartShow = true
    },
    // 自定义仪表盘添加图表
    addChartConfirm() {
      this.dashboardForm.chartData.forEach((item) => {
        this.$set(item, 'i', item.chartId)
        this.$set(item, 'x', 0)
        this.$set(item, 'y', 0)
        this.$set(item, 'w', 4)
        this.$set(item, 'h', 4)
      })
      const rowData = this.rowData.filter((item) => {
        return item.businessType === this.tabItem.dashboardType
      })
      this.rowData = rowData.filter((item) =>
        this.dashboardForm.chartData.every((v) => v.chartId !== item.chartId)
      )
      this.addChartList = this.rowData
      this.customChart.push(...this.dashboardForm.chartData)
      this.addChartCancel()
    },
    // 自定义仪表盘添加图表取消按钮
    addChartCancel() {
      this.addChartShow = false
      this.chartName = ''
    },
    // 添加仪表盘保存
    dialogConfirm() {
      if (!this.dashboardForm.name.trim()) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceDashboard.dashboardNamePlaceholder'))
        return
      }
      // 0是BI仪表盘，1是自定义仪表盘
      if (this.dashboardForm.type === 0 && !this.dashboardForm.biDashboardSource) {
        this.$message.warning(this.$t('BiAnalysis.SelectBIDashboardSource'))
        return
      }
      // 0是BI仪表盘，1是自定义仪表盘
      if (this.dashboardForm.type === 0 && (!this.dashboardForm.dashboardId || Number(this.dashboardForm.dashboardId) <= 0)) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceDashboard.biDashboardIdPlaceholder'))
        return
      }
      if (this.dialogType === 'add') {
        if (this.nameList.includes(this.dashboardForm.name)) {
          this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceDashboard.saveTips1'))
          return
        }
        if (this.dashboardForm.type === 1 && this.dashboardForm.chartData.length === 0) {
          this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceDashboard.saveTips'))
          return
        }
        this.addSave()
      }
      if (this.dialogType === 'edit') {
        if (this.tabItem.name !== this.dashboardForm.name) {
          for (let i = this.nameList.length - 1; i >= 0; i--) {
            if (this.nameList[i] === this.dashboardForm.name) {
              this.$message.warning(this.$t('BusinessIntelligence.businessIntelligenceDashboard.saveTips1'))
              return
            }
          }
        }
        this.editSave()
      }
    },
    // 打开编辑仪表盘
    async editDashboard() {
      this.dialogType = 'edit'
      this.dialogTitle = `编辑${this.tabItem.name}`
      this.dashboardForm = { ...this.tabItem }
      this.$set(this.dashboardForm, 'dataAccess', [String(this.tabItem.accessDataType)])
      this.checkedId = this.dashboardForm.dataAccess[0]
      if (this.tabItem.accessCompanyId !== '0') {
        this.dashboardForm.accessCompanyId = this.tabItem.accessCompanyId.split(',')
        this.dashboardForm.accessCompanyId = this.dashboardForm.accessCompanyId.map(Number)
      } else {
        this.dashboardForm.accessCompanyId = Number(this.tabItem.accessCompanyId)
      }
      this.accessCompanyList = []
      if (Object.prototype.toString.call(this.dashboardForm.accessCompanyId) === '[object Array]') {
        for (const officeId of this.dashboardForm.accessCompanyId) {
          const uuidList = getFilterCacheList(cacheKeys.basic_data_Office, (item) => {
            return item.officeId === Number(officeId)
          })
          this.accessCompanyList.push(uuidList[0].uuid)
        }
      }
      if (this.tabItem.accessDeptId !== '0') {
        this.dashboardForm.accessDeptId = this.tabItem.accessDeptId.split(',')
        this.dashboardForm.accessDeptId = this.dashboardForm.accessDeptId.map(Number)
      } else {
        this.dashboardForm.accessDeptId = Number(this.tabItem.accessDeptId)
      }
      if (this.tabItem.accessUserId !== '0') {
        this.dashboardForm.accessUserId = this.tabItem.accessUserId.split(',')
        this.dashboardForm.accessUserId = this.dashboardForm.accessUserId.map(Number)
      } else {
        this.dashboardForm.accessUserId = Number(this.tabItem.accessUserId)
      }
      if (Object.prototype.toString.call(this.dashboardForm.accessUserId) === '[object Array]') {
        this.selectAllPersonnel = false
      } else {
        this.selectAllPersonnel = true
        this.dashboardForm.accessUserId = []
      }
      this.selectBranch(this.dashboardForm.accessCompanyId, 'edit')
      this.getPersonnelList(this.dashboardForm.accessDeptId, 'edit')
      this.addDashboardShow = true
    },
    // 仪表盘弹窗右侧图表查询
    async queryChart(value, type) {
      const data = {
        showAll: value
      }
      if (this.dialogType === 'edit') {
        data.dashboardId = this.dashboardForm.dashboardId
      }
      this.loading = getLoading()
      const res = await getCards(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.rowData = res.data
        // 'addChart'为自定义仪表盘添加图表按钮时传入参数,表示需要过滤掉当前已添加过的图表
        if (type === 'addChart') {
          if (this.tabItem.children.length > 0) {
            const rowData = this.rowData.filter((item) => {
              return item.businessType === this.tabItem.dashboardType
            })
            this.rowData = rowData.filter((item) =>
              this.customChart.every((v) => v.chartId !== item.chartId)
            )
            this.addChartList = this.rowData
          } else {
            this.addChartList = this.rowData
          }
        } else {
          if (this.rowData.length > 0) {
            this.chartList = this.rowData.filter((item) => {
              return item.businessType === this.dashboardForm.dashboardType
            })
          }
        }
      }
    },
    // 自定义仪表盘切换仪表盘分类时更新右侧列表为相应数据
    selectDashbaordType(value) {
      this.chartList = this.rowData.filter((item) => {
        return item.businessType === value
      })
    },
    // 自定义仪表盘弹窗右侧查询过滤
    searchChart() {
      if (this.chartName) {
        this.chartList = this.rowData.filter((item) => {
          return (item.name).indexOf(this.chartName) !== -1 && this.dashboardForm.dashboardType === item.businessType
        })
      } else {
        this.selectDashbaordType(this.dashboardForm.dashboardType)
      }
    },
    // 自定义仪表盘添加图表过滤查询
    filterChart() {
      if (this.chartName) {
        this.addChartList = this.rowData.filter((item) => {
          return (item.name).indexOf(this.chartName) !== -1
        })
      } else {
        this.addChartList = this.rowData
      }
    },
    // 切换选择数据权限
    statusChanges() {
      if (this.dashboardForm.dataAccess.length > 1) {
        this.dashboardForm.dataAccess.splice(0, 1)
        this.checkedId = this.dashboardForm.dataAccess[0]
      } else {
        this.dashboardForm.dataAccess.push(this.checkedId)
      }
    },
    // 打开添加仪表盘弹窗
    async addDashboard() {
      this.dashboardForm.dataAccess = ['4']
      this.$refs['form'] ? this.$refs['form'].resetFields() : ''
      this.dialogTitle = this.$t('BusinessIntelligence.businessIntelligenceDashboard.addDashboard')
      this.queryChart(true)
      this.dialogType = 'add'
      this.addDashboardShow = true
    },
    // 添加仪表盘窗口关闭
    dialogCancel() {
      this.addDashboardShow = false
      this.chartName = ''
      this.addChartList = []
      this.rowData = []
      // 初始化数据时，默认为自定义仪表盘，一瞬间会展开右侧，体验不好，加定时器
      // 延迟初始化数据
      setTimeout(() => {
        this.dashboardForm = {
          type: 1,
          dashboardType: 0,
          name: '',
          biDashboardSource: '',
          dashboardId: '',
          remark: '',
          accessCompanyId: [],
          accessDeptId: [],
          accessUserId: [],
          dataAccess: ['3'],
          chartData: []
        }
        this.accessCompanyList = []
        this.selectAllBranch = true
        this.selectAllDepartment = true
        this.selectAllPersonnel = true
      }, 300)
    },
    // 删除自定义仪表盘内部图表
    async deletes(item) {
      this.customChart = this.customChart.filter((i) => {
        return i.chartId !== item.chartId
      })
    },
    // 温馨提示
    prompt() {
      const messages = []
      const h = this.$createElement
      messages.push(h('p', null, this.$t('BusinessIntelligence.businessIntelligenceDashboard.prompt1')))
      messages.push(h('p', null, this.$t('BusinessIntelligence.businessIntelligenceDashboard.prompt2')))
      messages.push(h('p', null, this.$t('BusinessIntelligence.businessIntelligenceDashboard.prompt3')))
      messages.push(h('p', null, this.$t('BusinessIntelligence.businessIntelligenceDashboard.prompt4')))
      messages.push(h('p', null, this.$t('BusinessIntelligence.businessIntelligenceDashboard.prompt5')))
      this.$confirm(this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
        title: this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'),
        message: h('div', null, messages),
        confirmButtonText: this.$t('BusinessIntelligence.businessIntelligenceChart.confirmButtonText'),
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      })
    },
    // 全屏展示
    fullScreen() {
      if (this.freeCustomer) {
        this.defaultDashboardClicked()
        return
      }
      if (this.freeDashboard && this.isBiDashboard) {
        window.open(this.matchImg(this.tabItem.name))
        return
      }
      window.open(this.tabItem.url, '_blank')
    },
    // 获取分公司
    async prepareData() {
      await cache.load(cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.accessPermissions.branchList.push(...cache.officeList)
    },
    // 勾选所有分公司
    changeBranchAll(value) {
      if (value) {
        this.selectAllDepartment = true
        this.selectAllPersonnel = true
      }
      this.accessCompanyList = []
      this.dashboardForm.accessCompanyId = []
      this.dashboardForm.accessDeptId = []
      this.dashboardForm.accessUserId = []
    },
    // 勾选所有部门
    changeDepartmentAll(value) {
      if (value) {
        this.selectAllPersonnel = true
      }
      this.dashboardForm.accessDeptId = []
      this.dashboardForm.accessUserId = []
    },
    // 勾选所有人员
    changePersonnelAll() {
      this.dashboardForm.accessUserId = []
    },
    // 根据分公司获取部门
    async selectBranch(data, type) {
      let dataArr = []
      if (type === 'edit') {
        // 编辑时，如果传入的是数组，则是多选，如果传入的不是数组，则数据返回的是0.则为全部
        if (Object.prototype.toString.call(data) === '[object Array]') {
          this.selectAllBranch = false
          dataArr = data
        } else {
          this.selectAllBranch = true
          this.dashboardForm.accessCompanyId = []
        }
      } else {
        // 新增时，选择的数据是对象，value才为具体的数组id值
        dataArr = data.value
        this.dashboardForm.accessCompanyId = []
      }
      this.accessPermissions.departmentList = []
      if (dataArr.length > 0) {
        for (const officeUuid of dataArr) {
          // 编辑状态传入的事officeId 先根据id拿到uuid  才能顺利展示在列表中，再根据
          // uuid拿到对应的部门展示在下拉框中
          if (type === 'edit') {
            // 根据返回的officeId查看对应的uuid
            const uuidList = getFilterCacheList(cacheKeys.basic_data_Office, (item) => {
              return item.officeId === officeUuid
            })
            // 根据找到的uuid查找对应的部门
            uuidList.map((uuidItem) => {
              const departments = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
                return item.officeUuid === uuidItem.uuid
              })
              this.accessPermissions.departmentList.push(...departments)
            })
          } else {
            // 新增时，传入的是uuid  根据uuid拿到对应的officeId参数，同时根据uuid获取对应的部门放入到下拉框中
            const uuidList = getFilterCacheList(cacheKeys.basic_data_Office, (item) => {
              return item.uuid === officeUuid
            })
            this.dashboardForm.accessCompanyId.push(uuidList[0].officeId)
            const departments = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
              return item.officeUuid === officeUuid
            })
            this.accessCompanyList = data.value
            this.accessPermissions.departmentList.push(...departments)
          }
        }
        if (type !== 'edit') {
          this.dashboardForm.accessDeptId = []
          this.dashboardForm.accessUserId = []
        }
      }
    },
    // 获取部门下的人员
    async getPersonnelList(dataArr, type) {
      let newArr = []
      if (type === 'edit') {
        if (Object.prototype.toString.call(dataArr) === '[object Array]') {
          this.selectAllDepartment = false
          newArr = dataArr
        } else {
          this.selectAllDepartment = true
          this.dashboardForm.accessDeptId = []
        }
      } else {
        newArr = dataArr.value
      }
      this.dashboardForm.accessDeptId = newArr
      if (newArr.length > 0) {
        const newData = []
        const userIdSet = new Set()
        for (const item of newArr) {
          const data = {
            deptId: item
          }
          const res = await getUsersByOfficeAndDept(data)
          if (res.ok) {
            for (const user of res.data) {
              if (userIdSet.has(user.userId)) {
                continue
              }
              newData.push(user)
              userIdSet.add(user.userId)
            }
          }
        }
        this.accessPermissions.personnelList = JSON.parse(JSON.stringify(newData))
        if (type !== 'edit') {
          this.dashboardForm.accessUserId = []
        }
      }
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        this.$router.push('/')
      }
    },
    // 免费仪表盘图标
    matchImg(name) {
      return BiConstants.getCodeByName(name)
    },
    // 默认仪表盘点击事件
    defaultDashboardClicked() {
      // isDefaultDashboard 判断是否是默认仪表盘
      // matchImg 判断免费仪表盘
      if (!this.freeCustomer) {
        return
      }
      if (this.isDefaultDashboard || BiConstants.isFreeCustomer(this.tabItem.name)) {
        this.$confirm(this.$t('BusinessIntelligence.businessIntelligenceDashboard.prompt6'), this.$t('Message.WarmReminder'), {
          confirmButtonText: this.$t('Message.GotIt'),
          showCancelButton: false,
          type: 'warning'
        })
      }
    },
    toDepartmentLabel(item) {
      if (item) {
        const officeCode = ColumnUtils.resolveColumnLabel(cacheKeys.basic_data_Office_All, 'uuid', item.officeUuid, 'code')
        return '[' + officeCode + ']' + item.chineseName
      }
      return ''
    },
    toUserLabel(item) {
      if (item) {
        const officeCode = ColumnUtils.resolveColumnLabel(cacheKeys.basic_data_Office_All, 'officeId', item.defaultOfficeId, 'code')
        return '[' + officeCode + ']' + item.chineseName
      }
      return ''
    }
  }
}
</script>
<style lang="scss">
.businessIntelligenceDashboard{
  display: flex !important;
  flex-direction: row !important;
  position: relative;
  .tab-list{
    background: #fff;
    width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y:auto;
    .tab-item{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px 5px;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: #ecf5ff;
        color: #409eff;
      }
    }
    .selectColor{
      background: #ecf5ff;
      color: #409eff;
    }
  }
  .dashboard-right{
    flex: 1;
    margin-left: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .operation{
      margin-top: 10px;
    }
    .dashboard{
      margin-top: 10px;
      flex: 1;
      overflow: hidden;
      .custom-operation{
        height: 40px;
      }
      .scroll{
        overflow-y: auto;
      }
      .dashboard-content{
        flex: 1;
        .dashboard-item{
          width: 100%;
          height: 100%;
          display: flex;
          border-radius: 5px;
          background: #fff;
          position: relative;
          .dashboard-item-operation{
            background: #ffffff;
            border-radius: 2px;
            padding: 0 10px 10px 10px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 52px;
            i{
              font-size: 20px;
              cursor: pointer;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
  .dialog-content{
    display: flex;
    .content-left{
      flex: 1 ;
    }
    .content-right{
      flex: 1;
      display: flex;
      flex-direction: column;
      .content-right-title{
        font-size: 14px;
        color: #333333;
      }
      .content-right-operation{
        margin-top:10px;
        display: flex;
      }
    }
    .permissions{
      border-top: 1px solid #ccc;
      margin-top: 10px;
      .permissions-title{
        margin: 10px 0;
        display: flex;
        align-items: flex-start;
        .color-piece{
          width: 4px;
          height: 12px;
          background: #1F75D5;
          display: inline-block;
          margin-right:5px;
        }
        span{
          margin-right:5px;
        }
      }
    }
    .input-width{
      width:200px;
    }
  }
  .query-item-footer{
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .custom-dialog{
    padding:0 10px;
    box-sizing:border-box;
    display: flex;
    .custom-dialog-left, .custom-dialog-right{
      display: flex;
      flex-direction: column;
      flex: 1;
      .custom-dialog-item{
        margin-top: 20px;
        .item-left{
          display: inline-block;
          width: 50px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
    .custom-dialog-right{
      display: flex;
      flex-direction: column;
      .configuration{
        margin: 5px 0 0 5px;
        width: 100%;
        flex: 1;
        .img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .mask{
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.3) ;
    position: absolute;
    left: 0;
    top: 0;
    .close{
      font-size: 22px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }
    .mask-content{
      width: 90%;
      height: 90%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
    }
  }
  .set-input{
    height:28px;
    border: 1px solid #DCDFE6;
    text-indent: 6px;
    font-size:12px;
    width:200px;
    &:focus{
      outline-style: none;
      border: 1px solid #226cc1;
      border-radius: 1px;
    }
  }
  .align-center{
    display: flex;
    align-items: center;
  }
}
</style>
